var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSuccessPopup = function SvgIconSuccessPopup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.5,
    height: 52.5,
    "data-name": "Group 10594"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#21c479",
    d: "M44.811 7.689a26.249 26.249 0 1 0 0 37.122 26.25 26.25 0 0 0 0-37.122m-3.093 34.028a21.874 21.874 0 1 1 0-30.935 21.873 21.873 0 0 1 0 30.935",
    "data-name": "Path 5915"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#21c479",
    d: "M37.828 16.64 24.062 30.406l-7.2-7.2a2.188 2.188 0 1 0-3.094 3.094l8.75 8.75a2.19 2.19 0 0 0 3.094 0l15.312-15.312a2.188 2.188 0 1 0-3.094-3.094Z",
    "data-name": "Path 5916"
  })));
};
export default SvgIconSuccessPopup;